// removed by extract-text-webpack-plugin
module.exports = {"dialog-bg-color":"#fffeff","border-color":"#969696","dialog-close-fg-color":"#969696","dialog-close-fg-hover-color":"#1c1b1c","duration":"0.5s","modal":"wM7h2yjG7a8FELDgfCyfI","showModal":"_1eCr21ZBva0Qw-hP3ZeuF0","dialog":"_3yQR7yMd6TQD6mmH2JwBkd","showDialog":"_3IcmVmLIVs4w8mydYG_0CK","closing":"_2FNeCNhIVLtynDbRbLuwu","hideModal":"_1gFWKlbwxvtRnrIyHRzLPU","hideDialog":"_2rf2jEN4NrsPWk1SvBqhi-","dialogContainer":"_2FeHqdGQc7Ttzz_d4WJh4l"};


//////////////////
// WEBPACK FOOTER
// ./src/views/fragments/dialog/style.css
// module id = 762
// module chunks = 0